import Immutable                           from 'immutable';
import _                                   from 'lodash';
import { CHANGE_PARAMETER, QUOTE_SUCCESS } from 'pu-redux/actions/QuoteActions';
import DefaultParameters                   from '../data/DefaultParameters';

const calculateIndex = (size) => {
  const n = _.toNumber(size);
  if (n < 0 || n > 10)
    return '';
  // the matrix is 1 by 1
  return '0';
};

const updateValue = (name, value, state) => {
  let prms;
  switch (name) {
    case 'stencil_length_text':
      prms = state.set(name, value);
      prms = prms.set('column_selected', calculateIndex(value));
      return prms;
    case 'stencil_width_text':
      prms = state.set(name, value);
      prms = prms.set('row_selected', calculateIndex(value));
      return prms;
    case 'quantities':
      return state.set(name, Immutable.List(value));
    default:
      return state.set(name, value);
  }
};

const parameters = (state = Immutable.fromJS(DefaultParameters), action) => {
  switch (action.type) {
    case CHANGE_PARAMETER: {
      const { name, value } = action;
      return updateValue(name, value, state);
    }
    case QUOTE_SUCCESS: {
      return state.withMutations((s) => {
        s.set('product_quote_number', action.quote.number)
      });
    }

    default:
      return state;
  }
};

export default parameters;
